var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-root", attrs: { id: "app-root" } },
    [
      _c(
        "a",
        {
          staticClass: "sr-only sr-only-focusable",
          attrs: { href: "#maincontent" }
        },
        [_vm._v(_vm._s(_vm.$t("Sr_ToMainContent")))]
      ),
      _vm._v(" "),
      _c("nav-menu"),
      _vm._v(" "),
      _vm.showBanner
        ? _c("info-banner", {
            staticClass: "content-container",
            attrs: { banner: _vm.banner }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("cookie-consent-dialog", { attrs: { show: !_vm.isConsented } }),
      _vm._v(" "),
      _c("terms-of-use-dialog", {
        attrs: { allowShow: _vm.allowShowTerms },
        on: { termsRead: _vm.onCloseTermsModal }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-container", attrs: { id: "maincontent" } },
        [
          _c("div", { staticClass: "spacer pt-5" }),
          _vm._v(" "),
          _c("router-view"),
          _vm._v(" "),
          _c("notifications", {
            attrs: {
              "aria-live": "polite",
              group: "global",
              position: "bottom right"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }